module.exports = __webpack_public_path__ + "img/brand-logo.f46eb8ea.png";